/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Meta_TitleInputs */

const es_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata — Asistente de negocios con IA`)
};

const en_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata — AI-Powered Business Assistant`)
};

/**
* | output |
* | --- |
* | "Nexata — AI-Powered Business Assistant" |
*
* @param {Home_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_meta_title = /** @type {((inputs?: Home_Meta_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Meta_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_meta_title(inputs)
	return en_home_meta_title(inputs)
});
export { home_meta_title as "home.meta.title" }